import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { SolutionComponent } from './solution/solution.component';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { LayoutsRoutingModule } from '../layouts/layouts-routing.module';
import { LayoutsModule } from '../layouts/layouts.module';
import { WhoweserveComponent } from './whoweserve/whoweserve.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { WhycyclopsComponent } from './whycyclops/whycyclops.component';

@NgModule({
  declarations: [
    AboutUsComponent,
    ContactUsComponent,
    SolutionComponent,
    WhoweserveComponent,
    WhycyclopsComponent
  ],
  imports: [
    CommonModule,
    RouterModule ,
    ReactiveFormsModule ,
    SharedModule ,
    LayoutsRoutingModule,
    LayoutsModule,
    CarouselModule,
    
  ],
  exports: [
    AboutUsComponent,
    ContactUsComponent,
    SolutionComponent,
    WhoweserveComponent,
    WhycyclopsComponent
  ]
})
export class PagesModule {}
